export default "__VITE_ASSET__BKqmba$D__"